var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1319 7.36565H12.6365V12.4109C12.6365 12.943 12.2049 13.375 11.6724 13.375H8.91024V10.1165C8.91024 9.60318 8.702 9.13828 8.36543 8.80171C8.02934 8.46561 7.56444 8.25737 7.05112 8.25737C6.0245 8.25737 5.19201 9.08939 5.19201 10.1165V13.375H2.42989C1.8973 13.375 1.46578 12.943 1.46578 12.4109V7.36565H0.970327C0.0659167 7.36565 -0.344923 6.23561 0.348428 5.65461L5.8125 1.07521C6.52935 0.474931 7.5729 0.474931 8.28975 1.07521L13.7538 5.65461C14.4472 6.23561 14.0363 7.36565 13.1319 7.36565Z",
    fill: "#E5BFE9"
  })));
};
export default SvgHouse;